<template>

  <div class="">
    <div class="table-responsive" style="border: 0">
      <table id="usersStatsTable" class="table table-striped table-bordered table-hover "
             style="font-size: 10px;width: 100%">
        <thead>
        <tr>
          <th></th>
          <th>#Ref</th>
          <th>FirstName</th>
          <th>LastName</th>
          <th>Email</th>
          <th>Phone</th>
          <th>Company</th>
          <th>Country</th>
          <th>Role</th>
          <th>Profile</th>
          <th>Plan</th>
          <th>Supervisor</th>
          <th>Total Projects</th>
          <th>Total Searches</th>
          <th>Sciences queries</th>
          <th>Patent queries</th>
          <th>Company queries</th>
          <th>News queries</th>
          <th>AI Chat queries</th>
          <th>Total Questions</th>
          <th>Total Mailings</th>
          <th>Total Shared Documents</th>
          <th>Total Shared Projects</th>
          <th>Enable</th>
          <th>Registered</th>
          <th>Last Login</th>
          <th>Expiration Date</th>
          <th v-if="$auth.user().plan.account_provisioning === 1">Action</th>
        </tr>
        </thead>
      </table>
    </div>
  </div>
</template>

<style>
  .btnDisable, .btnEnable {
    font-size: 13px;
    padding: 0px 3px
  }

</style>

<script>
import 'datatables.net-select-bs/css/select.bootstrap.min.css'
import 'datatables.net-select-bs/js/select.bootstrap.min'

export default {
  components: {},
  props: [],
  name: 'UsersStats',
  data () {
    return {
      dataTable: null,
      selectedRows: []
    }
  },
  mounted () {
    let customColumnDefs = []
    if (this.$auth.user().plan.account_provisioning === 1) {
      customColumnDefs.push({
        targets: 27,
        data: null,
        searchable: false,
        defaultContent: '<router-link  class="btn btn-xs btn-block btn-info btn-outline editUser">' +
          '<i class="fas fa-pencil-alt"></i> Edit </router-link>'
      })
    }

    customColumnDefs.push({
      orderable: false,
      searchable: false,
      className: 'select-checkbox',
      targets: 0
    })

    this.dataTable = $('#usersStatsTable').DataTable({
      pageLength: 100,
      responsive: true,
      processing: true,
      serverSide: true,
      bPaginate: true,
      dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>t<'row'<'col-sm-3'i><'col-sm-6 text-center'p><'col-sm-3'>>",
      ajax: {
        url: process.env.API_URL + '/stats/users?relations={profile,company,company.country,supervisor,planCredit,planCredit.plan,roles}',
        dataSrc: 'data',
        beforeSend: function (request) {
          request.setRequestHeader('Authorization', 'Bearer ' + localStorage.default_auth_token
          )
        }
      },
      columns: [
        {data: null, defaultContent: '', searchable: false, orderable: false},
        {data: 'id', searchable: true, orderable: true },
        {data: 'firstname'},
        {data: 'lastname'},
        {data: 'email'},
        {data: 'phone'},
        {data: 'company', name: 'company.name', orderable: false},
        {data: 'country', name: 'company.country.name', orderable: false},
        {data: 'role', name: 'roles.name', orderable: false},
        {data: 'profile', name: 'profile.name', orderable: true, visible: !!this.$auth.check('super_admin')},
        {data: 'plan', name: 'planCredit.plan.name', searchable: false, orderable: false},
        {data: 'supervisor', name: 'supervisor.lastname', searchable: false, orderable: false},
        {data: 'stats.projects', name: 'stats.projects', searchable: false, orderable: false},
        {data: 'stats.searches', name: 'stats.searches', searchable: false, orderable: false},
        {data: 'stats.nbSearches.science', name: 'stats.nbSearches.science', searchable: false, orderable: false},
        {data: 'stats.nbSearches.patent', name: 'stats.nbSearches.patent', searchable: false, orderable: false},
        {data: 'stats.nbSearches.company', name: 'stats.nbSearches.company', searchable: false, orderable: false},
        {data: 'stats.nbSearches.news', name: 'stats.nbSearches.news', searchable: false, orderable: false},
        {data: 'stats.nbSearches.aichat', name: 'stats.nbSearches.aichat', searchable: false, orderable: false},
        {data: 'stats.questions', name: 'stats.questions', searchable: false, orderable: false},
        {data: 'stats.mailings', name: 'stats.mailings', searchable: false, orderable: false},
        {data: 'stats.shareDocument', name: 'stats.shareDocument', searchable: false, orderable: false},
        {data: 'stats.shareProject', name: 'stats.shareProject', searchable: false, orderable: false},
        {data: 'enabled'},
        {data: 'created_at'},
        {data: 'last_login'},
        {data: 'expired_at', name: 'planCredit.expired_at'}
      ],
      rowId: 'id',
      columnDefs: customColumnDefs,
      // 'stateSave': true,
      'select': true,
      createdRow: (row, data, index) => {
        let col = this.$auth.check('super_admin') ? 23 : 21
        let td = $('td', row).eq(col)
        if (data['enabled'] * 1 > 0) {
          td.html('<span class="btn-success btnEnable"><i class="fa fa-check"></i></span>')
        } else {
          td.html('<span class="btn-danger btnDisable" ><i class="fa fa-times"></i></span>')
        }
        td.attr('align', 'center')
        td.css('vertical-align', 'middle')
      },
      initComplete: () => {
        this.manageSelects()
      },
      buttons: [
        {
          text: 'Select page',
          className: 'btn btn-xs btn-info btn-outline',
          action: () => {
            this.dataTable.rows({
              page: 'current'
            }).select()
          }
        },
        {
          text: 'Unselect All',
          className: 'btn btn-xs btn-info btn-outline',
          action: () => {
            this.selectedRows = []
            this.dataTable.rows().deselect()
          }
        },
        {extend: 'copy', className: 'btn btn-xs btn-warning btn-outline'},
        {extend: 'csv', text: 'export as csv', className: 'btn btn-xs btn-warning btn-outline'}
      ]
    })

    let self = this
    $('#usersStatsTable tbody').on('click', '.editUser', function (e) {
      e.stopPropagation()
      let data = self.dataTable.row($(this).parents('tr')).data()
      let routeData = self.$router.resolve({name: 'ManageUser', params: {id: data['id']}})
      window.open(routeData.href, '_blank')
    })
  },
  methods: {
    getSelectedRows () {
      return this.selectedRows
    },
    manageSelects () {
      let $api = this.dataTable

      $api.on('select', (e, dt, type, indexes) => {
        indexes.forEach((index) => {
          let rowId = $api.row(index).data().id
          let exist = this.selectedRows.find(value => {
            return rowId === value
          })

          if (typeof exist === 'undefined') {
            this.selectedRows.push(rowId)
          }
        })
      })

      $api.on('deselect', (e, dt, type, indexes) => {
        indexes.forEach((index) => {
          let rowId = $api.row(index).data().id
          this.selectedRows = this.selectedRows.filter((value) => {
            return value !== rowId
          })
        })
      })

      $api.on('draw.dt', () => {
        this.selectedRows.forEach((id) => {
          $api.row('#' + id).select()
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/stats/usersStats.vue